import React, {useContext, useState, useEffect} from 'react'
import {BaseUrl} from "contexts/baseUrl/baseUrl";
import localization from "../../../../assets/localization/localization";
import Layout from "../../../../components/sales/layout/layout";
import CustomModal from "../../../valetServices/modal";
import DivLayout from "../../../../components/sales/divLayout/divLayout";
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";
import DropDownInput from "../../../../components/sales/Input/dropDownInput/dropDownInput";
import {Button} from "react-bootstrap";
import {toast} from "react-toastify";
import moment from "moment";

const DismantleMrf = ({
                          match,
                          getDismantleSite,
                          dismantleSiteResponse = [],
                          fetchSubCategoryType,
                          subCategoryType = [],
                          dismantleMrfResponse = [],
                          getDismantleMrf,
                          contractDate,
                          contractDateResponse = [],
                          history
                      }) => {

    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [additionalItems, setAdditionalItems] = useState([{category_id: '', item_id: '', quantity: 1}])
    const [materialList, setMaterialList] = useState([[]])
    const [oldMaterialList, setOldMaterialList] = useState([])
    const [contractDateCheck, setContractDate] = useState(false)
    const [count, setCount] = useState(0);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getDismantleSite(match?.params?.site_id)
            await contractDate(match?.params?.site_id)
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (contractDateResponse) {
            setContractDate(false)
            let date = moment(contractDateResponse).format('YYYY-MM-DD');
            const date1 = new Date(date);
            const date2 = new Date('2023-04-01');
            if (date1 > date2) {
                setContractDate(true)
            }
        }
    }, [contractDateResponse])

    const handleItemsAdd = () => {
        setAdditionalItems([
            ...additionalItems,
            {
                category_id: "",
                item_id: "",
                quantity: 1,
            },
        ]);
    };

    const handleItemRemove = (index) => {
        const list = [...additionalItems];
        list.splice(index, 1);
        setAdditionalItems(list);
    };


    const materialByCategoryId = async (category_id, index) => {
        if (!category_id) {
            return false
        }
        const res = await fetchSubCategoryType(category_id)
        if (res) {
            materialList[index] = res
            setMaterialList(materialList)
        }
    }

    const handleNewInput = (key, value, index) => {
        let list = [...additionalItems]
        if (key === 'quantity' && (value <= 0 || !value)) {
            list[index]['quantity'] = 1
            setAdditionalItems(list)
            toast.warning("Quantity must be greater than 0 of new added items")
        } else {
            list[index][key] = value
        }
        setAdditionalItems(list)
    }

    const handleOldInput = (key, value, index, materialId) => {
        let list = [...oldMaterialList];
        list[index]['serab'] = list[index]['actual_quantity'] - value;
        list[index]['quantity'] = value;
        setOldMaterialList(list);
    }

    useEffect(() => {
        if (dismantleSiteResponse?.line_items) {
            let list = [...oldMaterialList]
            // eslint-disable-next-line array-callback-return
            dismantleSiteResponse?.line_items.map((val, i) => {
                list.push({
                    serab: val.quantity,
                    item_id: val?.material_id,
                    quantity: 0,
                    actual_quantity: val.quantity
                })
            })

            setOldMaterialList(list)
        }
    }, [dismantleSiteResponse])

    const handleSubmit = async () => {
        let isValidate = false;
        let msg = '';
        if (oldMaterialList.length > 0) {
            oldMaterialList.map((val, i) => {
                if ((parseInt(val?.serab) + parseInt(val?.quantity)) < parseInt(val?.quantity)) {
                    isValidate = true
                    msg = "Dismantle quantity can't be greater than available quantity"
                }
            })
        }

        if (additionalItems[0].category_id === '') {
            toast.warning("Please select new items")
            return false
        }

        if (isValidate) {
            toast.warning(msg)
            return false
        }

        const list = {
            installment_mrf: oldMaterialList,
            dismantle_mrf: additionalItems,
            site_id: match?.params?.site_id,
            installment_mrf_id: dismantleSiteResponse?.id
        }

        if (!contractDateCheck) {
            delete list['installment_mrf']
        }
        setIsLoading(true)
        await getDismantleMrf(list)
        setIsLoading(false)
        setCount(count + 1);
    }

    // Laravel nested response.status is 200/400. Go V2 normalizer sets
    // response.status to boolean true/false (and leaves numeric 0/1 on the body).
    const isDismantleMrfSuccess =
        dismantleMrfResponse?.status === 200 ||
        dismantleMrfResponse?.status === true ||
        dismantleMrfResponse?.status === 0;
    const hasDismantleMrfResponse =
        dismantleMrfResponse !== null &&
        typeof dismantleMrfResponse === 'object' &&
        !Array.isArray(dismantleMrfResponse) &&
        Object.keys(dismantleMrfResponse).length > 0;

    return (
        <>
            <Layout
                title={localization.BacktoList}
                isGoback
                isLoading={isLoading}
                style={{height:"100%"}}
            >
                {hasDismantleMrfResponse && !isDismantleMrfSuccess && (
                        <CustomModal
                            msg={dismantleMrfResponse?.message}
                            click={count}
                            history={history}
                        />
                    )}
                {hasDismantleMrfResponse && isDismantleMrfSuccess && (
                        <CustomModal
                            msg={dismantleMrfResponse?.message}
                            isPageLoad={true}
                            click={count}
                            url={`${baseUrl}/site-listing`}
                            history={history}
                        />
                    )}
                {contractDateCheck && dismantleSiteResponse?.line_items &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">{localization.materialDetails}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    {dismantleSiteResponse?.id &&
                                        <DivLayout
                                            heading={"MRF Id"}
                                            data={
                                                dismantleSiteResponse?.id
                                            }
                                        />
                                    }

                                    {dismantleSiteResponse?.client_name &&
                                        <DivLayout
                                            heading={"Client Name   "}
                                            data={
                                                dismantleSiteResponse?.client_name
                                            }
                                        />
                                    }

                                </div>
                            </div>
                            <div className="panel-card card-details">
                                <div className="panel-heading">Installation Mrf</div>
                                <div className="panel-body">
                                    <div className="details-listing detail_alignment">
                                        <table className="table">
                                            <thead style={{backgroundColor: '#0559ae', color: 'white'}}>
                                            <th>Item</th>
                                            <th>Quantity</th>
                                            <th>Update Quantity</th>
                                            </thead>
                                            <tbody>
                                            {dismantleSiteResponse?.line_items.map((val, i) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>
                                                                {val?.material_name}
                                                            </td>
                                                            <td>
                                                                {val?.quantity}
                                                            </td>
                                                            <td>
                                                                <div className="col-sm-12">
                                                                    <ConstantInput
                                                                        label={"Dismantle Quantity"}
                                                                        value={""}
                                                                        type="number"
                                                                        handleChange={(value) =>
                                                                            handleOldInput('quantity', value, i, val?.material_id)
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                    </>
                                                )
                                            })
                                            }

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                }


                {dismantleSiteResponse?.categories &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">Additional New Line Items</div>
                            <div className="panel-body">
                                <table className="table">
                                    <thead style={{backgroundColor: '#0559ae', color: 'white'}}>
                                    <th>Category</th>
                                    <th>Material</th>
                                    <th>Quantity</th>
                                    <th>Action</th>
                                    </thead>
                                    <tbody>
                                    {additionalItems.map((val, i) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td>
                                                        <DropDownInput
                                                            label={'Categories'}
                                                            data={dismantleSiteResponse?.categories}
                                                            getIdValue={(val) => {
                                                                materialByCategoryId(val?.id, i);
                                                                handleNewInput('category_id', val.id, i);
                                                            }}
                                                            value={""}
                                                            isStarRequired={true}
                                                            required={true}
                                                        />
                                                    </td>
                                                    <td>
                                                        <DropDownInput
                                                            label={'Material'}
                                                            data={materialList[i]}
                                                            getIdValue={(val) => {
                                                                handleNewInput('item_id', val.id, i);
                                                            }}
                                                            value={""}
                                                            isStarRequired={true}
                                                            required={true}
                                                        />
                                                    </td>
                                                    <td>
                                                        <div className="col-sm-12">
                                                            <ConstantInput
                                                                label={localization.quantity}
                                                                value={val.quantity}
                                                                type="number"
                                                                handleChange={(value) =>
                                                                    handleNewInput('quantity', value, i)
                                                                }
                                                                required={true}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="d-flex">
                                                        {additionalItems.length !== 1 && (
                                                            <>
                                                                <button
                                                                    onClick={() => handleItemRemove(i)}
                                                                    className="btn btn-sm btn-danger mr10"
                                                                >
                                                                    Remove
                                                                </button>
                                                            </>
                                                        )}
                                                        {additionalItems.length - 1 === i && (
                                                            <button
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => handleItemsAdd()}
                                                            >
                                                                Add
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-12 mb-2">
                                <center>
                                    <Button onClick={handleSubmit}>
                                        {localization.submitDtl}
                                    </Button>
                                </center>
                            </div>
                        </div>
                    </>
                }

            </Layout>
        </>
    )
}

export default DismantleMrf